import { Button, Flex, Result, Typography } from "antd";

import s from "./NotFoundPage.module.css";
import { NotFoundPageProps } from "./types";

const { Title } = Typography;

export const NotFoundPage = ({
  title,
  description,
  homeButtonLabel,
  onNavigateHome,
}: NotFoundPageProps) => {
  return (
    <Flex align="center" justify="center" className={s.container}>
      <Result
        icon={
          <Title className={s.title} level={1}>
            404
          </Title>
        }
        title={title}
        subTitle={description}
        data-testid="not-found-page-result"
        extra={
          <Button
            type="primary"
            onClick={onNavigateHome}
            data-testid="not-found-page-button"
          >
            {homeButtonLabel}
          </Button>
        }
      />
    </Flex>
  );
};
